"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _DateDisplay = _interopRequireDefault(require("./DateDisplay.css"));

/**
 * This should handle a range rather than only the from date.
 * This has been pushed to later to accomodate the current frontend needs.
 */
var DateDisplay =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(DateDisplay, _React$PureComponent);

  function DateDisplay() {
    (0, _classCallCheck2.default)(this, DateDisplay);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DateDisplay).apply(this, arguments));
  }

  (0, _createClass2.default)(DateDisplay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          from = _this$props.from,
          to = _this$props.to;
      var momentFrom = _moment.default.isMoment(from) ? from : (0, _moment.default)(from);
      var momentTo = _moment.default.isMoment(to) ? to : (0, _moment.default)(to);
      return React.createElement("div", {
        className: classes.container
      }, React.createElement(_Typography.default, {
        variant: 'dateDisplay',
        className: "top ".concat(classes.top)
      }, momentFrom.format('MMM')), React.createElement("div", {
        className: classes.bottomLeft
      }, React.createElement(_Typography.default, {
        variant: 'dateDisplay',
        className: 'bottom'
      }, momentFrom.date())));
    }
  }]);
  return DateDisplay;
}(React.PureComponent);

DateDisplay.propTypes = {
  /**
   * The date that will be treated as a from date.
   */
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(Object)]).isRequired,

  /**
   * The date that will be treated as a to date.
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(Object)])
};

var _default = (0, _styles.withStyles)(_DateDisplay.default)(DateDisplay);

exports.default = _default;